import React from 'react';
import ReactSelect from 'react-select';

import { defaultStyles, mergeSelectStyles } from '../../utils';

import { AvatarSelectOption, type AvatarOption } from './avatar-select-option';
import type { SelectRefType, SelectProps } from '../../types';

import styles from './avatar-select.module.scss';

export const AvatarSelect = React.forwardRef<
  SelectRefType<AvatarOption>,
  SelectProps<AvatarOption>
>(
  (
    {
      options,
      value,
      defaultValue = [],
      styles,
      onChange,
      isMulti,
      isLoading,
      isDisabled,
      isClearable,
      label,
      required,
      errorMessage,
      ...props
    },
    ref,
  ) => {
    const currentStyles = mergeSelectStyles(defaultStyles<AvatarOption>(), styles);

    return (
      <div className={styles['container']}>
        {label && (
          <label className={styles['label']}>
            {label} {required && <b>*</b>}
          </label>
        )}

        <ReactSelect
          ref={ref}
          {...props}
          options={options}
          defaultValue={defaultValue}
          value={value}
          onChange={onChange}
          styles={currentStyles}
          isClearable={isClearable}
          isMulti={isMulti}
          isLoading={isLoading}
          isDisabled={isLoading || isDisabled}
          isOptionDisabled={(option) => !!option.disabled}
          components={{
            Option: AvatarSelectOption,
          }}
        />

        {errorMessage && <span className={styles['error']}>{errorMessage}</span>}
      </div>
    );
  },
);

AvatarSelect.displayName = 'AvatarSelect';
